const cardData = [
  {
    title: '某选秀节目选手自曝遭不公待遇，节目组连夜发声明',
    excerpt: '热门选秀节目《星光之路》参赛选手在社交平台发文，详细披露节目录制期间的种种不公...',
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20style%20editorial%20image%20with%20warm%20lighting%20and%20soft%20focus%2C%20abstract%20TV%20studio%20backstage%20atmosphere%2C%20dramatic%20yet%20subtle%20composition%2C%20coral%20and%20beige%20tones%2C%20magazine%20quality&width=800&height=534&seq=card-news-01&orientation=landscape',
    tag: '选秀风波',
    time: '2小时前',
    comments: '1.2万',
  },
  {
    title: '知名导演新片选角引争议，网友喊话换人重拍',
    excerpt: '著名导演张导新片公布主演阵容后引发网友热议，不少粉丝表示对选角结果不满...',
    image: 'https://readdy.ai/api/search-image?query=Film%20production%20atmosphere%20with%20warm%20cinematic%20lighting%2C%20director%20chair%20and%20equipment%20in%20soft%20focus%2C%20beige%20and%20warm%20gray%20tones%2C%20editorial%20photography%20style%2C%20professional%20film%20set&width=800&height=534&seq=card-news-02&orientation=landscape',
    tag: '电影争议',
    time: '4小时前',
    comments: '9.8千',
  },
  {
    title: '娱乐圈模范夫妻被传婚变，双方工作室齐发声明',
    excerpt: '被粉丝称为娱乐圈模范夫妻的两位艺人今日被传出婚姻出现危机，双方工作室紧急发布联合声明...',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20couple%20silhouette%20with%20warm%20backlighting%2C%20soft%20romantic%20atmosphere%2C%20abstract%20editorial%20style%2C%20coral%20and%20cream%20tones%2C%20gentle%20gradient%20background%2C%20magazine%20quality&width=800&height=534&seq=card-news-03&orientation=landscape',
    tag: '婚变传闻',
    time: '5小时前',
    comments: '2.5万',
  },
  {
    title: '年度最受期待综艺官宣阵容，顶流云集引热议',
    excerpt: '备受关注的年度综艺《明星大挑战》正式官宣本季嘉宾阵容，多位一线明星确认加盟...',
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20colorful%20warm%20spotlights%2C%20entertainment%20atmosphere%2C%20soft%20coral%20and%20gold%20tones%2C%20editorial%20photography%2C%20professional%20lighting%2C%20celebrity%20event%20vibe&width=800&height=534&seq=card-news-04&orientation=landscape',
    tag: '综艺热议',
    time: '6小时前',
    comments: '3.1万',
  },
  {
    title: '某歌手新专辑涉嫌抄袭海外作品，当事人回应来了',
    excerpt: '知名歌手发布的新专辑主打歌被网友指出旋律与某海外热门单曲高度相似，引发抄袭争议...',
    image: 'https://readdy.ai/api/search-image?query=Music%20recording%20studio%20atmosphere%20with%20warm%20ambient%20lighting%2C%20headphones%20and%20microphone%20in%20soft%20focus%2C%20creative%20artistic%20vibe%2C%20beige%20and%20warm%20gray%20tones%2C%20editorial%20quality&width=800&height=534&seq=card-news-05&orientation=landscape',
    tag: '抄袭争议',
    time: '8小时前',
    comments: '1.8万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-100">
            <i className="ri-article-line text-primary-500 text-lg"></i>
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">热门资讯</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11 md:pl-12">最新最热的八卦资讯，一网打尽</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardData.map((card) => (
            <article
              key={card.title}
              className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer group flex flex-col"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-white text-xs font-medium">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col gap-2 flex-1">
                <h3 className="font-heading font-bold text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{card.excerpt}</p>
                <div className="flex items-center gap-3 mt-auto pt-2 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-1-line"></i>
                    {card.comments}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}